const notificaciones = {
    ObtenLosAcuerdosPorFolio: 'EQUITAS/NotificacionElectronicaAntiguo/ObtenLosAcuerdosPorFolio',
    EnviaLosCorreoDeLaNotificacionElectronica: 'EQUITAS/NotificacionElectronicaAntiguo/EnviaLosCorreoDeLaNotificacionElectronica'
}

export default notificaciones


//////////////////
// WEBPACK FOOTER
// ./static/js/api/EQUITAS/sistema/notificaciones/notificaciones.js
// module id = null
// module chunks = 